import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminTranscriptReviewService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminTranscriptReviewKeys } from 'app/queries/adminTranscriptReview/adminTranscriptReviewKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminTranscriptReviewKeys.styleFixChunk>>;

export const createFetchStyleFixFixtureChunkQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, chunkIndex }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminTranscriptReviewService.getStyleFixFixtureChunk({ jobId, chunkIndex }), signal), {
      dontRedirectOnError: true,
    });
